// src/pages/Noticias.jsx
import React, { useState, useEffect, Suspense } from 'react';
import { Helmet } from 'react-helmet';
import PageFooter from '../components/PageFooter';
import NoticiaFiltro from '../components/Noticias/NoticiaFiltro';
import NoticiaGrid from '../components/Noticias/NoticiaGrid';
import Recommended from '../components/ModeloDestacado/ModeloDestacado';
import GeneralContacto from '../components/HomeContacto/HomeContacto';
import styles from './Noticias.module.scss';

const LazyPageBanner = React.lazy(() => import('../components/PageBanner'));

const Noticias = () => {
  const [noticias, setNoticias] = useState([]);
  const [filtered, setFiltered] = useState([]);
  const [visible, setVisible] = useState(6);
  const [order, setOrder] = useState('reciente');

  const sortArray = (arr, ord) =>
    arr.slice().sort((a, b) =>
      ord === 'reciente'
        ? new Date(b.fechaPublicacion) - new Date(a.fechaPublicacion)
        : new Date(a.fechaPublicacion) - new Date(b.fechaPublicacion)
    );

  useEffect(() => {
    const fetchNoticias = async () => {
      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/noticias?populate=previsualizacion`
        );
        const { data } = await res.json();
        const arr = data.map(n => ({
          documentId: n.documentId,
          titulo: n.titulo,
          slug: n.slug,
          bajada: n.bajada,
          previsualizacion: n.previsualizacion?.[0]?.url || '',
          fechaPublicacion: n.publishedAt || n.createdAt,
        }));
        const sorted = sortArray(arr, 'reciente');
        setNoticias(sorted);
        setFiltered(sorted);
      } catch (err) {
        console.error('Error fetching noticias:', err);
      }
    };
    fetchNoticias();
  }, []);

  const handleSearch = term => {
    const f = noticias.filter(n =>
      n.titulo.toLowerCase().includes(term.toLowerCase())
    );
    setFiltered(sortArray(f, order));
  };

  const handleSort = ord => {
    setFiltered(sortArray(filtered, ord));
    setOrder(ord);
  };

  const handleLoadMore = () => {
    setVisible(v => v + 3);
  };

  return (
    <>
      <Helmet>
        <title>Zoomlion Latinoamérica | Noticias</title>
        <meta
          name="description"
          content="Conoce las últimas noticias de Zoomlion en Latinoamérica. Somos la marca líder en 19 países."
        />
      </Helmet>

      <div className={styles.page}>
        <div className={styles.banner}>
          <Suspense fallback={<div>Loading Banner...</div>}>
            <LazyPageBanner />
          </Suspense>
        </div>

        <h2 className={styles.heading}>Buscar noticias</h2>
        <div className={styles.filter}>
          <NoticiaFiltro onSearch={handleSearch} onSort={handleSort} />
        </div>

        <h2 className={styles.headingResults}>Resultados</h2>
        <div className={styles.gridContainer}>
          <NoticiaGrid noticias={filtered.slice(0, visible)} />
        </div>

        {filtered.length > visible && (
          <div className={styles.loadMoreContainer}>
            <button
              className={styles.loadMoreButton}
              onClick={handleLoadMore}
            >
              CARGAR MÁS
            </button>
          </div>
        )}

        <Recommended />

        <GeneralContacto />

        <div className={styles.footer}>
          <PageFooter />
        </div>
      </div>
    </>
  );
};

export default Noticias;
